// extracted by mini-css-extract-plugin
module.exports = {"outer":"_26Pg7","text":"_2rIMj"};